import React, { useEffect, useState } from 'react';
import customerReturnService from '../../services/customerReturnService';
import { formatPrice } from '../../helpers/utility';

export function useSalesReturns(documents) {
  const [state, setState] = useState({ data: {}, error: false });
  const references = JSON.stringify([...new Set((documents || []).map(d => d.numero).filter(Boolean))]);
  useEffect(() => {
    let active = true;
    const refs = JSON.parse(references);
    setState({ data: {}, error: false });
    if (refs.length) customerReturnService.linked(refs).then(response => {
      if (active) setState({ data: response.data || {}, error: false });
    }).catch(() => { if (active) setState({ data: {}, error: true }); });
    return () => { active = false; };
  }, [references, documents]);
  return state;
}

export default function SalesReturns({ document, state }) {
  const returns = state.data[document.numero] || [];
  if (state.error) return <small className="text-danger">Retours indisponibles</small>;
  if (!returns.length) return null;
  const total = returns.reduce((sum, r) => sum + Number(r.montantTTC || 0), 0);
  return <details className="mt-2 text-start" onClick={event => event.stopPropagation()}>
    <summary className="text-primary">{returns.length} retour(s) · Net : {formatPrice(Number(document.montantTotalTTC || 0) - total, false)} DH</summary>
    <div className="small p-2 border rounded bg-light">
      <div>Vente initiale : {formatPrice(document.montantTotalTTC, false)} DH</div>
      <div>Retourné : {formatPrice(total, false)} DH</div>
      {returns.map(retour => <details key={retour.id} className="mt-2">
        <summary>{retour.numeroRetour} · {retour.dateOperation} · {formatPrice(retour.montantTTC, false)} DH</summary>
        <div>Ticket / BL : {retour.numBL}</div>
        <div>{retour.modeRemboursement === 'REMBOURSEMENT' ? 'Remboursement' : 'Avoir'} · {retour.motifRetour}</div>
        <ul className="mb-0">{(retour.lignes || []).map((line, index) => <li key={line.id || index}>{line.articleNom} × {line.quantiteRetournee}</li>)}</ul>
      </details>)}
    </div>
  </details>;
}
